import React from 'react'

import { useTranslation } from 'react-i18next'

import { Badge } from '@/shared/components/atoms/Badge/Badge'

interface DraftBadgeProps {
	visible: boolean
	className?: string
}

export const DraftBadge: React.FC<DraftBadgeProps> = ({
	visible,
	className = '',
}) => {
	const { t } = useTranslation('common')

	if (!visible) return null

	return (
		<Badge variant="secondary" className={`text-xs ${className}`}>
			{t('common.draft')}
		</Badge>
	)
}
